import { useContext, useState, useEffect, useRef, createElement } from "react";
import {
  StyleSheet,
  View,
  Text,
  TextInput,
  Dimensions,
  Platform,
} from "react-native";
import SafeAreaView from "../components/SafeAreaView";
import InputField from "../components/InputField";

import { AuthContext } from "../context/AuthContext";
import * as Config from "../config";
import axios from "axios";
import qs from "qs";
import MessdatenList from "../components/MessdatenList";
import PageHeader from "../components/PageHeader";

//import Feather from "react-native-vector-icons/Feather";
//import Ionicons from "react-native-vector-icons/Ionicons";

import { Feather } from "../components/VectorIcons";
import { Ionicons } from "../components/VectorIcons";

import MessDiagramm from "../components/MessDiagramm";
import * as ScreenOrientation from "expo-screen-orientation";
import ExportIcon from "../components/ExportIcon";
import Toast from "react-native-root-toast";
import { timeValue, exportData, getSchemeStyle } from "../context/helper";
import { EventRegister } from "react-native-event-listeners";
import ActivityScreen from "./activityscreen";
import SimplePress from "../components/SimplePress";
import { Modal } from "../components/Modal";
import CustomButton from "../components/CustomButton";

const SensorScreen = ({ route, navigation }) => {
  const schemeStyles = getSchemeStyle();

  const [landscape, setLandscape] = useState(false);
  const [diagrammSize, setDiagrammSize] = useState(600);

  useEffect(() => {
    checkOrientation();
    const subscription = ScreenOrientation.addOrientationChangeListener(
      handleOrientationChange
    );
    return () => {
      ScreenOrientation.removeOrientationChangeListener(subscription);
    };
  }, []);

  const refreshOrientation = (o) => {
    let { width, height } = Dimensions.get("window");

    let lscape = [3, 4].indexOf(o) >= 0;

    if ((lscape && width < height) || (!lscape && width > height)) {
      let w = width;
      width = height;
      height = w;
    }

    let dgSize =
      width < height
        ? Math.min(width - 20, 600)
        : Math.min(width / 2 - 30, 600);

    setLandscape(lscape);
    setDiagrammSize(dgSize);
  };
  const checkOrientation = async () => {
    let o = await ScreenOrientation.getOrientationAsync();
    refreshOrientation(o);
  };
  const handleOrientationChange = (o) => {
    refreshOrientation(o.orientationInfo.orientation);
  };

  const { userToken, userInfo, useFirm } = useContext(AuthContext);
  const { branchid, sensorid } = route.params;

  const [dataLoaded, setDataLoaded] = useState(false);
  const [sensorData, setSensorData] = useState([]);
  const [branchName, setBranchName] = useState("");
  const [fromDate, setFromDate] = useState(new Date());
  const [toDate, setToDate] = useState(new Date());

  const [lastTime, setLastTime] = useState(new Date());
  const [lastValue, setLastValue] = useState(-99);
  const [lastUnit, setLastUnit] = useState("");

  const [remarks, setRemarks] = useState({});
  const [selectedItem, setSelectedItem] = useState(null);
  const [remarkItem, setRemarkItem] = useState(null);
  const [remarkText, setRemarkText] = useState("");
  const [remarkVisible, setRemarkVisible] = useState(false);
  const [savingRemark, setSavingRemark] = useState(false);

  const firstLoad = useRef(true);

  const loadData = async (from, to) => {
    setDataLoaded(false);

    const url = `${Config.BASE_URL}/getdata`;
    if (!from) from = new Date();
    if (!to) to = new Date();
    let data = {
      action: "sensordetail",
      firmid: useFirm.current,
      branchid: branchid,
      sensorid: sensorid,
      datefrom: from,
      dateto: to,
      firstload: firstLoad.current?1:0
    };
    let options = {
      method: "POST",
      headers: {
        "content-type": "application/x-www-form-urlencoded",
        Authorization: "Bearer " + userToken,
      },
      data: qs.stringify(data),
      url,
    };
    await axios(options)
      .then((res) => {
        let _sensordata = res.data;
        // console.log(_sensordata.data);
        if (_sensordata && _sensordata.result == "OK") {
          if (firstLoad.current) {
            setFromDate(new Date(_sensordata.data.datefrom));
          }
          setBranchName(_sensordata.branchName);
          setSensorData(_sensordata);
          const loadedRemarks = {};
          _sensordata.data.data.forEach((item) => {
            if (item.remark) loadedRemarks[item.id] = item.remark;
          });
          setRemarks(loadedRemarks);
          setSelectedItem(null);

          if (
            _sensordata.data.data.length > 0 &&
            Math.floor(new Date().getTime() / 86400000) ===
              Math.floor(from.getTime() / 86400000)
          ) {
            setLastValue(_sensordata.data.data[0].value);
            setLastUnit(_sensordata.data.data[0].unit);
            setLastTime(_sensordata.data.data[0].time);
          }
        }
      })
      .catch((e) => {
        console.log(`SensorDetail error ${e}`);
      });
    firstLoad.current = false;
    setDataLoaded(true);
  };

  useEffect(() => {
    loadData(fromDate, toDate);
  }, []);
  useEffect(() => {
    const emitSubscribe = EventRegister.addEventListener(
      Config.Events.BRANCH_CHANGE,
      (msg) => {
        if (branchid===msg.branchid)
          setBranchName(msg.branchname);
      }
    );
    return () => {
      EventRegister.removeEventListener(emitSubscribe);
    };
  }, [branchid]);

  if (!dataLoaded) {
    return (
      <ActivityScreen />
    );
  }

  const Schwellenwerte = (von, bis, unit) => {
    let werte;
    if (von===0)
      von=false;
    if (von===-0.01)
      von=0;
    if (bis===0)
      bis=false;
    if (bis===-0.01)
      bis=0;

    if ((von!==false) && (bis!==false)) werte = von + unit + " bis " + bis + unit;
    else if (von!==false) werte = "von " + von + unit;
    else werte = "bis " + bis + unit;

    return `Schwellenwerte: ${werte}`;
  };

  const checkSchwellenwerte = (value) => {
    if (sensorData.data.minvalue !== 0 || sensorData.data.maxvalue !== 0) {
      if (sensorData.data.minvalue !== 0 && sensorData.data.maxvalue !== 0) {
        return (
          value >= sensorData.data.minvalue && value <= sensorData.data.maxvalue
        );
      } else if (sensorData.data.minvalue !== 0) {
        return value >= sensorData.data.minvalue;
      } else return value <= sensorData.data.maxvalue;
    }
    return true;
  };

  const handleItemPress = (item) => {
    setSelectedItem((prev) => (prev?.id === item.id ? null : item));
  };

  const openRemarkModal = () => {
    if (!selectedItem) return;
    setRemarkItem(selectedItem);
    setRemarkText(remarks[selectedItem.id] ?? selectedItem.remark ?? "");
    setRemarkVisible(true);
  };

  const saveRemark = async () => {
    if (!remarkItem) return;
    setSavingRemark(true);
    const url = `${Config.BASE_URL}/getdata`;
    let data = {
      action: "setmeasuringremark",
      firmid: useFirm.current,
      sensorid: sensorid,
      dataid: remarkItem.id,
      remark: remarkText,
    };
    let options = {
      method: "POST",
      headers: {
        "content-type": "application/x-www-form-urlencoded",
        Authorization: "Bearer " + userToken,
      },
      data: qs.stringify(data),
      url,
    };
    await axios(options)
      .then((res) => {
        if (res.data?.result === "OK") {
          setRemarks((prev) => ({ ...prev, [remarkItem.id]: remarkText }));
          setRemarkVisible(false);
        }
      })
      .catch((e) => {
        console.log(`SetRemark error ${e}`);
      });
    setSavingRemark(false);
  };

  const toastMsgText = (name, isok) => {
    switch (name) {
      case "print":
        return `Daten ${isok ? "" : "nicht "}gedruckt`;
      case "xml":
        return `XML ${isok ? "" : "nicht "}exportiert`;
      case "csv":
        return `CSV ${isok ? "" : "nicht "}exportiert`;
      case "json":
        return `JSON ${isok ? "" : "nicht "}exportiert`;
      case "pdf":
        return `PDF ${isok ? "" : "nicht "}exportiert`;
    }
    return "";
  };

  let toast = null;
  const pressExport = async (name) => {
    let doexport = false;
    switch (name) {
      case "print":
      case "xml":
      case "csv":
      case "json":
      case "pdf":
        doexport = true;
        break;
    }

    if (doexport) {
      if (Platform.OS === "web")
        await exportData(name, {
          usertoken: userToken,
          firmid: useFirm.current,
          branchid: branchid,
          sensorid: sensorid,
          datefrom: fromDate,
          dateto: toDate,
        });
      else {
        let isok = await exportData(name, sensorData);

        if (toast) {
          Toast.hide(toast);
          toast = null;
        }

        toast = Toast.show(toastMsgText(name, isok), {
          duration: Toast.durations.LONG,
          position: Toast.positions.BOTTOM,
          shadow: true,
          animation: true,
          hideOnPress: true,
          delay: 0,
          onShow: () => {
            // calls on toast\`s appear animation start
          },
          onShown: () => {
            // calls on toast\`s appear animation end.
          },
          onHide: () => {
            // calls on toast\`s hide animation start.
          },
          onHidden: () => {
            // calls on toast\`s hide animation end.
            toast = null;
          },
        });
      }

      // You can manually hide the Toast, or it will automatically disappear after a `duration` ms timeout.
      // setTimeout(function () {
      //  Toast.hide(toast);
      //}, 500);
    }
  };

  const MyWebDatePicker = ({ value, onChange }) => {
    return createElement("input", {
      type: "date",
      value: value.toISOString().split("T")[0],
      onChange: (event) => {
        onChange(new Date(event.target.value));
      },
      style: {
        height: 30,
        padding: 5,
        border: "2px solid #677788",
        borderRadius: 5,
        width: 250,
      },
    });
  };
  return (
    <SafeAreaView style={[styles.mainContainer,schemeStyles.Background]}>
      <PageHeader navigation={navigation} showBack={true} />
      {sensorData.data ? (
        <>
          <View style={landscape && { flexDirection: "row", flexWrap: "wrap" }}>
            <View
              style={[
                styles.branchHeaderContainer,
                landscape && { minWidth: 350 },
              ]}
            >
              <View style={styles.infoContainer}>
                <Text style={[styles.branchHeaderText,schemeStyles.defaultText]}>
                  Sensor {sensorData.data.name}
                </Text>
                <Text style={[styles.branchHeader2Text,schemeStyles.defaultText]}>
                  Standort {branchName}
                </Text>
                {(sensorData.data.minvalue !== 0 ||
                  sensorData.data.maxvalue !== 0) && (
                  <Text style={schemeStyles.defaultText}>
                    {Schwellenwerte(
                      sensorData.data.minvalue,
                      sensorData.data.maxvalue,
                      sensorData.data.unit
                    )}
                  </Text>
                )}
                {sensorData.data.offline && <Text style={schemeStyles.defaultText}>Offlinesensor</Text>}
                {/* {sensorData.data.erroralways && (
                  <Text>Fehler immer melden</Text>
                )}*/}
              </View>
              {sensorData.data.data.length > 0 && (
                <View style={styles.timeContainer}>
                  {lastValue === -99 ? (
                    <View style={styles.noValue}>
                      <Feather name="minus" size={18} color={schemeStyles.defaultText.color} />
                      <Feather name="minus" size={18} color={schemeStyles.defaultText.color} />
                      <Feather name="minus" size={18} color={schemeStyles.defaultText.color} />
                    </View>
                  ) : (
                    <Text
                      style={[
                        styles.tempText,
                        schemeStyles.defaultText,
                        !checkSchwellenwerte(lastValue) && schemeStyles.errorText,
                      ]}
                    >
                      {lastValue}
                      {lastUnit}
                    </Text>
                  )}
                  <Text style={[styles.timeText,schemeStyles.defaultText]}>{timeValue(lastTime)}</Text>
                </View>
              )}
            </View>
            <View
              style={[
                styles.diagrammContainer,
                landscape && { flex: 1, minWidth: 400 },
              ]}
            >
              <View style={{ flex: 1 }}></View>
              <MessDiagramm
                size={Platform.OS === "web" ? 600 : diagrammSize}
                data={sensorData.data.data}
                minArea={sensorData.data.minvalue}
                maxArea={sensorData.data.maxvalue}
                style={[styles.diagrammStyle, schemeStyles.diagramBorder, schemeStyles.defaultText]}
              />
            </View>
          </View>
          {(userInfo.current.R_Export || userInfo.current.R_FirmAdmin || userInfo.current.R_Admin) && (
            <View
              style={{
                flexDirection: "row",
                marginHorizontal: 10,
                marginBottom: 10,
              }}
            >
              {((userInfo.current.R_FirmAdmin || userInfo.current.R_Admin)) && (
                <View style={{flexDirection: "row", alignItems: "center"}}>
                {selectedItem ? (
                  <SimplePress
                    onPress={openRemarkModal}
                    disabled={!selectedItem}
                    hitSlop={{ top: 8, bottom: 8, left: 12, right: 12 }}
                  >
                    <View style={styles.toolbarButton}>
                      <Feather
                        name="message-square"
                        size={26}
                        color={selectedItem ? "#4785b8" : (schemeStyles.disabledIcon?.color ?? "#aaa")}
                      />
                      <Text style={[
                        styles.toolbarButtonLabel,
                        { color: selectedItem ? "#4785b8" : (schemeStyles.disabledIcon?.color ?? "#aaa") },
                      ]}>
                        {(remarks[selectedItem.id])?"Bemerkung ändern":"neue Bemerkung"}
                      </Text>
                    </View>
                  </SimplePress>
                ) : (
                  <Text style={[styles.toolbarHint, schemeStyles.lightGrayText]} numberOfLines={1}>
                    Eintrag antippen zum Auswählen
                  </Text>
                )}
                </View>
              )}
              <View style={{ flex: 1 }}></View>
              {Platform.OS === "ios" && (
                <Feather
                  style={{marginRight: 20}}
                  name="printer"
                  size={36}
                  color={"#4785b8"}
                />
              )}
              <ExportIcon
                name="xml"
                size={40}
                color={"#4785b8"}
                onPress={pressExport}
              />
              <ExportIcon
                name="json"
                size={40}
                color={"#4785b8"}
                onPress={pressExport}
              />
              <ExportIcon
                name="csv"
                size={40}
                color={"#4785b8"}
                onPress={pressExport}
              />
              <ExportIcon
                name="pdf"
                size={40}
                color={"#4785b8"}
                onPress={pressExport}
              />
            </View>
          )}
          <View style={styles.dateselectContainer}>
            <View style={styles.inputContainer}>
              <Text style={[styles.inputLabel,schemeStyles.lightGrayText]}>von:</Text>
              <InputField
                style={[styles.inputField,schemeStyles.Background,schemeStyles.BorderC,schemeStyles.pickerStyle,schemeStyles.defaultText]}
                label={"Datum von"}
                value={fromDate.toISOString()}
                icon={
                  <Ionicons name="calendar-outline" size={24} color="#666" />
                }
                inputType={"datepicker"}
                onChangeText={(newdate) => {
                  setFromDate(newdate);
                  loadData(newdate, toDate);
                }}
              />
            </View>
            <View style={styles.inputContainer}>
              <Text style={[styles.inputLabel,schemeStyles.lightGrayText]}>bis:</Text>
              <InputField
                style={[styles.inputField,schemeStyles.Background,schemeStyles.BorderC, schemeStyles.pickerStyle,schemeStyles.defaultText]}
                label={"Datum bis"}
                value={toDate.toISOString()}
                icon={
                  <Ionicons name="calendar-outline" size={24} color="#666" />
                }
                inputType={"datepicker"}
                onChangeText={(newdate) => {
                  setToDate(newdate);
                  loadData(fromDate, newdate);
                }}
              />
            </View>
          </View>
          <MessdatenList
            data={sensorData.data.data}
            remarks={remarks}
            selectedId={selectedItem?.id}
            onItemPress={handleItemPress}
          />
          <Modal isOpen={remarkVisible} withInput>
            <View style={[styles.remarkModal, schemeStyles.Background]}>
              <Text style={[styles.remarkTitle, schemeStyles.defaultText]}>
                Bemerkung
              </Text>
              {remarkItem && (
                <Text style={[styles.remarkSubtitle, schemeStyles.lightGrayText]}>
                  {timeValue(remarkItem.time)}
                </Text>
              )}
              <TextInput
                style={[styles.remarkInput, schemeStyles.defaultText, schemeStyles.BorderC]}
                placeholder="Bemerkung eingeben..."
                placeholderTextColor={schemeStyles.placeholderText?.placeholderColor ?? "#888"}
                value={remarkText}
                onChangeText={setRemarkText}
                multiline
                numberOfLines={4}
              />
              <View style={styles.remarkButtons}>
                <CustomButton
                  style={[styles.cancelButton, styles.remarkButton]}
                  onPress={() => setRemarkVisible(false)}
                >
                  Abbrechen
                </CustomButton>
                <CustomButton
                  style={styles.remarkButton}
                  onPress={saveRemark}
                  disabled={savingRemark}
                >
                  Speichern
                </CustomButton>
              </View>
            </View>
          </Modal>
        </>
      ) : (
        <View>
          <Text>Fehler beim Laden</Text>
        </View>
      )}
    </SafeAreaView>
  );
};

export default SensorScreen;

const styles = StyleSheet.create({
  mainContainer: {
    flex: 1,
    paddingVertical: 20,
  },
  scrollContainer: {
    paddingHorizontal: 10,
  },
  branchHeaderContainer: {
    marginHorizontal: 20,
    marginBottom: 20,
    flexDirection: "row",
  },
  branchHeaderText: {
    fontSize: 18,
    fontFamily: "Roboto-Medium",
  },
  branchHeader2Text: {
    fontSize: 16,
    fontFamily: "Roboto-Medium",
  },
  infoContainer: {
    flex: 1,
  },
  timeContainer: {
    alignItems: "center",
  },
  tempText: {
    fontSize: 22,
    fontFamily: "Roboto-Medium",
  },
  timeText: {
    fontSize: 10,
    fontFamily: "Roboto-Regular",
  },
  dateselectContainer: {
    flexDirection: "row",
    paddingHorizontal: 10,
    marginBottom: 10,
  },
  inputContainer: {
    flexDirection: "row",
    flex: 1,
    marginHorizontal: 5,
    alignItems: "center",
  },
  inputLabel: {
    marginRight: 5,
    fontSize: 18,
  },
  inputField: {
    flex: 1,
    fontFamily: "Roboto-Regular",
    fontSize: 18
  },
  diagrammContainer: {
    paddingHorizontal: 10,
    flexDirection: "row",
  },
  diagrammStyle: {
    fontFamily: "Roboto-Regular",
  },
  noValue: {
    flexDirection: "row",
    justifyContent: "flex-end",
  },
  toolbar: {
    flexDirection: "row",
    alignItems: "center",
    paddingHorizontal: 14,
    paddingVertical: 6,
    borderTopWidth: 1,
    marginHorizontal: 10,
  },
  toolbarHint: {
    flex: 1,
    fontSize: 12,
    fontFamily: "Roboto-Regular",
  },
  toolbarButton: {
    flexDirection: "row",
    alignItems: "center",
    gap: 5,
  },
  toolbarButtonLabel: {
    fontSize: 13,
    fontFamily: "Roboto-Medium",
  },
  remarkModal: {
    width: "90%",
    borderRadius: 10,
    padding: 20,
  },
  remarkTitle: {
    fontSize: 18,
    fontFamily: "Roboto-Medium",
    marginBottom: 4,
  },
  remarkSubtitle: {
    fontSize: 13,
    fontFamily: "Roboto-Regular",
    marginBottom: 12,
  },
  remarkInput: {
    borderWidth: 1,
    borderRadius: 6,
    padding: 10,
    fontFamily: "Roboto-Regular",
    fontSize: 14,
    minHeight: 90,
    textAlignVertical: "top",
    marginBottom: 16,
  },
  remarkButtons: {
    flexDirection: "row",
    gap: 10,
  },
  remarkButton: {
    flex: 1,
    marginBottom: 0,
  },
  cancelButton: {
    backgroundColor: "#888",
  },
});
